import { getAPIURL } from 'constants/environment'
import { Locale } from 'date-fns'
import type { Block, DocumentBlockData, ImageBlockData, SubcontentBlockData } from 'shared/graphql/graphql'
import { getDateFormatByLocale, getFormattedFromDate, newDateWithoutTime } from 'utils/date'
import { BLOCK_TYPE, BLOCK_TYPE_PATH, PUBLISHER_URI_PATH } from '../constants'
import type { GetBlockSrc } from '../types'

export const getContentViewDate = ({ locale, date }: { locale?: Locale; date?: string }) => {
  const dateFormat = getDateFormatByLocale(locale as Locale, { withDayOfWeek: false, withYear: true })

  return getFormattedFromDate(newDateWithoutTime(date), dateFormat, locale)
}

export const getBlockSrc = ({ filename, type }: GetBlockSrc) =>
  filename ? `${getAPIURL()}${PUBLISHER_URI_PATH}${BLOCK_TYPE_PATH[type]}/${filename}` : ''

export const updateBlocks = (blocks: Block[] | undefined) =>
  blocks && blocks.length > 0
    ? blocks.map((block: Block) => ({
        data: {
          ...(block.data as object),
          ...(block.type === BLOCK_TYPE.document && {
            src: getBlockSrc({
              filename: (block.data as DocumentBlockData)?.filename ?? '',
              type: BLOCK_TYPE.document,
            }),
          }),
          ...(block.type === BLOCK_TYPE.image && {
            src: getBlockSrc({
              filename: (block.data as ImageBlockData)?.filename ?? '',
              type: BLOCK_TYPE.image,
            }),
          }),
          ...(block.type === BLOCK_TYPE.subcontent && {
            src: (block.data as SubcontentBlockData)?.previewImageFilename
              ? getBlockSrc({
                  filename: (block.data as SubcontentBlockData)?.previewImageFilename ?? '',
                  type: BLOCK_TYPE.image,
                })
              : undefined,
          }),
        },
        language: block.language,
        order: block.order,
        type: block.type,
      }))
    : []
